import { useState } from 'react'
import { useApiForm } from '../api-form'
import { useApiList } from '../api-list'
import { useApiWebsocket } from '../api-websocket'
import { urlArgs } from '../state'
import { inviteOutcome } from './invite-outcome'

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//DDD
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const useApiListGroup = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/group${urlArgs(args)}`)
export const useApiFormGroup = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/group${urlArgs(args)}`)

export const useApiListAsset = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/asset${urlArgs(args)}`)
export const useApiFormAsset = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/asset${urlArgs(args)}`)

export const useApiListNodeCourseVersion = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/node-course-version${urlArgs(args)}`)
export const useApiFormNodeCourseVersion = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/node-course-version${urlArgs(args)}`)

// export const useApiListAssetThumbnail = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/asset-thumbnail${urlArgs(args)}`)
// export const useApiFormAssetThumbnail = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/asset-thumbnail${urlArgs(args)}`)

// export const useApiListAssetUnityPackage = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/asset-unity-package${urlArgs(args)}`)
// export const useApiFormAssetUnityPackage = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/asset-unity-package${urlArgs(args)}`)

// export const useApiListNodeCourse = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/node-course${urlArgs(args)}`)
// export const useApiFormNodeCourse = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/node-course${urlArgs(args)}`)

// export const useApiListNodeCourseCategory = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/node-course-category${urlArgs(args)}`)
// export const useApiFormNodeCourseCategory = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/node-course-category${urlArgs(args)}`)

// export const useApiListNodeLibraryCategory = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/node-library-category${urlArgs(args)}`)
// export const useApiFormNodeLibraryCategory = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/node-library-category${urlArgs(args)}`)

// export const useApiListNodeTemplateCategory = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/node-template-category${urlArgs(args)}`)
// export const useApiFormNodeTemplateCategory = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/node-template-category${urlArgs(args)}`)

// export const useApiListNodeLibrary = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/node-library${urlArgs(args)}`)
// export const useApiFormNodeLibrary = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/node-library${urlArgs(args)}`)

// export const useApiListNodeTemplate = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/node-template${urlArgs(args)}`)
// export const useApiFormNodeTemplate = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/node-template${urlArgs(args)}`)

// export const useApiFormNodeMove = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/node-move${urlArgs(args)}`)

// export const useApiListNodeDecendant = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/node-decendant${urlArgs(args)}`)

// export const useApiListNodeDecendantContent = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/node-decendant/content${urlArgs(args)}`)

// export const useApiListNodeDecendantTemplate = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/node-decendant/template${urlArgs(args)}`)

// export const useApiListNodeDecendantLibrary = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/node-decendant/library${urlArgs(args)}`)

// export const useApiListNodeOrg = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/node-org${urlArgs(args)}`)
// export const useApiFormNodeOrg = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/node-org${urlArgs(args)}`)

// export const useApiListNodeGroup = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/node-group${urlArgs(args)}`)
// export const useApiListNodeUser = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/node-user${urlArgs(args)}`)
// export const useApiListGroupUser = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/group-user${urlArgs(args)}`)

// export const useApiListSaveType = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/save-type${urlArgs(args)}`)

// export const useApiListSaveItem = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/save-item${urlArgs(args)}`)
// export const useApiFormSaveItem = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/save-item${urlArgs(args)}`)

// export const useApiListSaveSnapshot = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/save-snapshot${urlArgs(args)}`)
// export const useApiFormSaveSnapshot = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/save-snapshot${urlArgs(args)}`)

// export const useApiListUserLogin = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/user-login${urlArgs(args)}`)
// export const useApiFormUserLogin = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/user-login${urlArgs(args)}`)

// export const useApiFormUserInvite = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/user-invite${urlArgs(args)}`)

// export const useApiFormRegisterUser = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/register-user${urlArgs(args)}`)

// export const useApiFormWhiteLabel = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/white-label${urlArgs(args)}`)

export const useApiListAssetVersion = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/asset-version${urlArgs(args)}`)
export const useApiFormAssetVersion = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/asset-version${urlArgs(args)}`)

export const useApiListPublishAsset = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/publish-asset${urlArgs(args)}`)
export const useApiFormPublishAsset = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/publish-asset${urlArgs(args)}`)

export const useApiListPublishAssetVersion = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/publish-asset-version${urlArgs(args)}`)
export const useApiFormPublishAssetVersion = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/publish-asset-version${urlArgs(args)}`)

export const useApiListAssetThumbnail = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/asset-thumbnail${urlArgs(args)}`)
export const useApiFormAssetThumbnail = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/asset-thumbnail${urlArgs(args)}`)

export const useApiListAssetUnityPackage = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/asset-unity-package${urlArgs(args)}`)
export const useApiFormAssetUnityPackage = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/asset-unity-package${urlArgs(args)}`)

export const useApiListNodeCourse = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/node-course${urlArgs(args)}`)
export const useApiFormNodeCourse = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/node-course${urlArgs(args)}`)

export const useApiListNodeCourseCategory = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/node-course-category${urlArgs(args)}`)
export const useApiFormNodeCourseCategory = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/node-course-category${urlArgs(args)}`)

export const useApiListNodeLibraryCategory = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/node-library-category${urlArgs(args)}`)
export const useApiFormNodeLibraryCategory = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/node-library-category${urlArgs(args)}`)

export const useApiListNodeTemplateCategory = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/node-template-category${urlArgs(args)}`)
export const useApiFormNodeTemplateCategory = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/node-template-category${urlArgs(args)}`)

export const useApiListNodeLibrary = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/node-library${urlArgs(args)}`)
export const useApiFormNodeLibrary = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/node-library${urlArgs(args)}`)

export const useApiListNodeTemplate = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/node-template${urlArgs(args)}`)
export const useApiFormNodeTemplate = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/node-template${urlArgs(args)}`)

export const useApiFormNodeMove = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/node-move${urlArgs(args)}`)

export const useApiListNodeDecendant = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/node-decendant${urlArgs(args)}`)

export const useApiListNodeDecendantContent = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/node-decendant/content${urlArgs(args)}`)

export const useApiListNodeDecendantTemplate = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/node-decendant/template${urlArgs(args)}`)

export const useApiListNodeDecendantLibrary = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/node-decendant/library${urlArgs(args)}`)

export const useApiListNodeOrg = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/node-org${urlArgs(args)}`)
export const useApiFormNodeOrg = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/node-org${urlArgs(args)}`)

export const useApiListNodeGroup = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/node-group${urlArgs(args)}`)
export const useApiListNodeUser = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/node-user${urlArgs(args)}`)
export const useApiListGroupUser = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/group-user${urlArgs(args)}`)

export const useApiListSaveType = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/save-type${urlArgs(args)}`)

export const useApiListSaveItem = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/save-item${urlArgs(args)}`)
export const useApiFormSaveItem = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/save-item${urlArgs(args)}`)

export const useApiListSaveSnapshot = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/save-snapshot${urlArgs(args)}`)
export const useApiFormSaveSnapshot = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/save-snapshot${urlArgs(args)}`)

export const useApiListUserLogin = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/user-login${urlArgs(args)}`)
export const useApiFormUserLogin = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/user-login${urlArgs(args)}`)

export const useApiFormUserInvite = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/user-invite${urlArgs(args)}`)

export const useApiFormRegisterUser = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/register-user${urlArgs(args)}`)

export const useApiFormWhiteLabel = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/white-label${urlArgs(args)}`)

export const useApiFormOrganizationUsage = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/organization-usage${urlArgs(args)}`)

///////////////////////////////////////
export const useApiListRoleSys = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/role-sys${urlArgs(args)}`)
export const useApiFormRoleSys = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/role-sys${urlArgs(args)}`)
export const useApiListRoleSysPermission = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/role-sys-permission${urlArgs(args)}`)
export const useApiFormRoleSysPermission = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/role-sys-permission${urlArgs(args)}`)
export const useApiListRoleSysScope = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/role-sys-scope${urlArgs(args)}`)
export const useApiListRoleSysLogin = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/role-sys-login${urlArgs(args)}`)

export const useApiListRoleOrg = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/role-org${urlArgs(args)}`)
export const useApiFormRoleOrg = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/role-org${urlArgs(args)}`)
export const useApiListRoleOrgPermission = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/role-org-permission${urlArgs(args)}`)
export const useApiFormRoleOrgPermission = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/role-org-permission${urlArgs(args)}`)
export const useApiListRoleOrgScope = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/role-org-scope${urlArgs(args)}`)
export const useApiListRoleOrgUser = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/role-org-user${urlArgs(args)}`)

export const useApiListRolePermission = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/role-permission${urlArgs(args)}`)
///////////////////////////////////////
// export const useApiListRoleOrg = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/v1/role-org${urlArgs(args)}`)
export const useApiFormRoleAccess = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/role-access${urlArgs(args)}`)
export const useApiListRoleScope = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/role-scope${urlArgs(args)}`)
export const useApiListRole = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/role${urlArgs(args)}`)
export const useApiListAccess = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/role-access${urlArgs(args)}`)
export const useApiListRoleUser = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/role-user${urlArgs(args)}`)

export const useApiListSysAdmin = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/login-sys-admin${urlArgs(args)}`)

// No hook reads every organization (about 9,500 on prod; it froze each page
// that did): pick, page and name organizations with shared/org-search.
// The recycle bin's switched-off organizations (get('deleted'), a handful)
// and restore (put(':id/restore')) only -- never .get() with no path.
export const useApiListOrganizationRecycle = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/organization${urlArgs(args)}`)
export const useApiFormOrganization = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/organization${urlArgs(args)}`)
// The owners' own organization deletion (content Task 21; always the token's
// organization): GET status + preflight, POST {confirmName} schedules, POST
// restore, GET pending (the organizations the caller can restore).
export const useApiFormOrganizationDeletion = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/organization-deletion${urlArgs(args)}`)

export const useApiListLogin = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/login${urlArgs(args)}`)
export const useApiFormLogin = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/login${urlArgs(args)}`)

export const useApiListLoginUser = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/login-user${urlArgs(args)}`)
export const useApiFormLoginUser = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/login-user${urlArgs(args)}`)

export const useApiListTradeshow = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/tradeshow${urlArgs(args)}`)
export const useApFormTradeshow = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/tradeshow${urlArgs(args)}`)

export const useApiListSelfRegister = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/ddd/self-register${urlArgs(args)}`)
export const useApFormSelfRegister = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/self-register${urlArgs(args)}`)

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// export const useApiListUserLogin = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/v1/user-login${urlArgs(args)}`)
// export const useApiFormUserLogin = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/v1/user-login${urlArgs(args)}`)


// export const useApiFormOrganization = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/v1/organization${urlArgs(args)}`)

// export const useApiListNodeUser = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/v1/node-user${urlArgs(args)}`)
// export const useApiListNodeGroup = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/v1/node-group${urlArgs(args)}`)

// export const useApiListTradeshow = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/v1/trade-show${urlArgs(args)}`)
// export const useApFormTradeshow = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/v1/trade-show${urlArgs(args)}`)

// export const useApiListLogin = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/v1/login${urlArgs(args)}`)
// export const useApiFormLogin = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/v1/login${urlArgs(args)}`)


// export const useApiListSysAdmin = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/v1/login-sys-admin${urlArgs(args)}`)
export const useApiFormSysAdmin = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/ddd/login-sys-admin${urlArgs(args)}`)

// export const useApiListGroupUser = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/v1/group-user${urlArgs(args)}`)

export const useApiListNodeCategory = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/v1/node-category${urlArgs(args)}`)
export const useApiFormNodeCategory = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/v1/node-category${urlArgs(args)}`)

////////////////////////////////////////////////////////////////////

// export const useApiListNodeCourse = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/v1/node-course${urlArgs(args)}`)
// export const useApiFormNodeCourse = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/v1/node-course${urlArgs(args)}`)

// export const useApiListNodeCourseCategory = args =>
//   useApiList(process.env.REACT_APP_API_CONTENT, `api/v1/node-course-category${urlArgs(args)}`)

// export const useApiFormNodeCourseCategory = args =>
//   useApiForm(process.env.REACT_APP_API_CONTENT, `api/v1/node-course-category${urlArgs(args)}`)

// export const useApiListNodeLibraryCategory = args =>
//   useApiList(process.env.REACT_APP_API_CONTENT, `api/v1/node-library-category${urlArgs(args)}`)

// export const useApiFormNodeLibraryCategory = args =>
//   useApiForm(process.env.REACT_APP_API_CONTENT, `api/v1/node-library-category${urlArgs(args)}`)

// export const useApiListNodeTemplateCategory = args =>
//   useApiList(process.env.REACT_APP_API_CONTENT, `api/v1/node-template-category${urlArgs(args)}`)

// export const useApiFormNodeTemplateCategory = args =>
//   useApiForm(process.env.REACT_APP_API_CONTENT, `api/v1/node-template-category${urlArgs(args)}`)

// export const useApiListNodeLibrary = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/v1/node-library${urlArgs(args)}`)
// export const useApiFormNodeLibrary = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/v1/node-library${urlArgs(args)}`)

// export const useApiListNodeTemplate = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/v1/node-template${urlArgs(args)}`)

// export const useApiFormNodeTemplate = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/v1/node-template${urlArgs(args)}`)

// export const useApiListAsset = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/v1/asset${urlArgs(args)}`)
// export const useApiFormAsset = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/v1/asset${urlArgs(args)}`)

// export const useApiListAssetThumbnail = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/v1/asset-thumbnail${urlArgs(args)}`)
// export const useApiFormAssetThumbnail = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/v1/asset-thumbnail${urlArgs(args)}`)

// export const useApiListAssetUnityPackage = args =>
//   useApiList(process.env.REACT_APP_API_CONTENT, `api/v1/asset-unity-package${urlArgs(args)}`)
// export const useApiFormAssetUnityPackage = args =>
//   useApiForm(process.env.REACT_APP_API_CONTENT, `api/v1/asset-unity-package${urlArgs(args)}`)

// export const useApiFormNodeMove = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/v1/node-move${urlArgs(args)}`)

// export const useApiListNodeDecendant = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/v1/node-decendant${urlArgs(args)}`)

// export const useApiListNodeDecendantContent = args =>
//   useApiList(process.env.REACT_APP_API_CONTENT, `api/v1/node-decendant/content${urlArgs(args)}`)

// export const useApiListNodeDecendantTemplate = args =>
//   useApiList(process.env.REACT_APP_API_CONTENT, `api/v1/node-decendant/template${urlArgs(args)}`)

// export const useApiListNodeDecendantLibrary = args =>
//   useApiList(process.env.REACT_APP_API_CONTENT, `api/v1/node-decendant/library${urlArgs(args)}`)

// export const useApiListNodeOrg = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/v1/node-org${urlArgs(args)}`)
// export const useApiFormNodeOrg = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/v1/node-org${urlArgs(args)}`)

////////////////////////////////////////////////////////////////////

// export const useApiFormNodeCourse = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/v1/node-course${urlArgs(args)}`)
export const useApiListNodeQuery = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/v1/node-meta-query${urlArgs(args)}`)

// Assets by their metadata, e.g. get('datatype:web_content'): the
// organization's assets whose current version is uploaded (the query the
// viewers run to find a course's bundles).
export const useApiListAssetQuery = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/v1/asset-meta-query${urlArgs(args)}`)

export const useApiListTemplate = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/v1/node-template${urlArgs(args)}`)

export const useApiFormTemplate = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/v1/node-template${urlArgs(args)}`)

export const useApiListNode = args => useApiList(process.env.REACT_APP_API_CONTENT, `api/v1/node${urlArgs(args)}`)
export const useApiFormNode = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/v1/node${urlArgs(args)}`)

export const useApiFormLoginPurge = args => useApiForm(process.env.REACT_APP_API_CONTENT, `api/v1/user-login-purge${urlArgs(args)}`)

//////////////////////////////////////////
//ROLE
//////////////////////////////////////////

//////////////////////////////////////////
//WEB SOCKET
//////////////////////////////////////////

// useUserInviteProgress: [start, progress, skipped] -- skipped lists the
// rows the server skipped as already members (invite-outcome.js).
export const useUserInviteProgress = onComplete => {
  const [connect] = useApiWebsocket(process.env.REACT_APP_API_CONTENT, 'api/ddd/user-invite/ws')

  const [progress, updateProgress] = useState(0)
  const [skipped, updateSkipped] = useState([])

  const handleOpen = () => {}

  const handleMessage = result => {
    updateProgress(result.progress)

    const outcome = inviteOutcome(result)
    if (outcome) {
      updateSkipped(list => [...list, outcome])
    }

    if (result.complete) {
      onComplete && onComplete(progress)
    }
  }

  const handleClose = () => {}

  const handleError = () => {}

  const start = async value => {
    updateSkipped([])

    const [init, send] = connect(handleOpen, handleMessage, handleClose, handleError)

    await init()
    await send(value)
  }

  return [start, progress, skipped]
}

// The launch bridge's check (/launch/content/:nodeID): GET <nodeID> ->
// { status: ok | no_web_build | removed | unavailable }, any signed-in caller.
export const useApiFormLaunchCheck = () => useApiForm(process.env.REACT_APP_API_CONTENT, 'api/ddd/launch-check')
